import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthGuard } from 'app/core/services/auth/auth-guard.service';
import {
  UsuarioPerfil,
  usuarioPerfilAdministrador,
  usuarioPerfilGerente,
  usuarioPerfilAtendente,
  usuarioPerfilRepresentante,
  usuarioPerfilFinanceiro
} from 'app/home/usuario';

export const acessosAnaliseMercado: UsuarioPerfil[] = [
  usuarioPerfilAdministrador,
  usuarioPerfilGerente,
  usuarioPerfilAtendente,
  usuarioPerfilRepresentante,
  usuarioPerfilFinanceiro
];

@Injectable({
  providedIn: 'root'
})
export class AnaliseMercadoGuard implements CanActivate {
  constructor(private authGuard: AuthGuard) {}

  canActivate(): boolean {
    return this.authGuard.canActivateAcesso(acessosAnaliseMercado);
  }
}
